<template>
  <ODialog ref="dialog" hideWhenLoading>
    <v-card v-if="allVehicles != null">
      <v-window v-model="currentTab" touchless>
        <!-- selecionando veículo -->
        <v-window-item :value="1">
          <v-card-text class="pa-0">
            <div class="pa-6">
              <v-text-field
                v-model="txtFilter"
                single-line
                hide-details
                class="py-0"
                autofocus
                placeholder="Buscar veículos..."
              />
            </div>

            <v-list class="py-0 maxh-4" style="border-radius: 0px">
              <v-list-item
                v-for="v in allVehicles"
                :key="v.id"
                class="px-6"
                @click="selectVehicle(v)"
              >
                <v-list-item-content>
                  <span>
                    <span class="mono">{{ v.code }}</span>
                    <span class="font-weight-thin ml-2">{{ v.org.name }}</span>
                  </span>
                </v-list-item-content>
                <v-list-item-action>
                  <v-icon>mdi-chevron-right</v-icon>
                </v-list-item-action>
              </v-list-item>
            </v-list>
          </v-card-text>
          <v-card-actions class="pa-6">
            <v-btn text large @click="$refs.dialog.$dismiss()">
              Cancelar
            </v-btn>
          </v-card-actions>
        </v-window-item>

        <!-- informando responsável -->
        <v-window-item :value="2">
          <v-card-text class="pa-0">
            <div class="pa-6">
              <v-text-field
                v-model="ownerName"
                label="Nome do responsável"
                hide-details
                @keyup.enter="apply()"
              />
            </div>
          </v-card-text>
          <ODialogButtons
            class="pa-6"
            @cancel="$refs.dialog.$dismiss()"
            @apply="apply()"
          />
        </v-window-item>
      </v-window>
    </v-card>
  </ODialog>
</template>

<script>
import _ from 'lodash'
import { Vehicle } from '@/models'

export default {
  components: {
    ODialog: require('oderon-vue/cpts/ODialog').default,
    ODialogButtons: require('oderon-vue/cpts/ODialogButtons').default
  },
  data() {
    return this.reset()
  },
  watch: {
    txtFilter() {
      this.debouncedFetchVehicles()
    }
  },
  created() {
    this.debouncedFetchVehicles = _.debounce(() => this.fetchVehicles(), 300)
  },
  methods: {
    reset() {
      return {
        currentTab: 1,
        row: null,
        txtFilter: '',
        allVehicles: null,
        selectedVehicle: null,
        ownerName: null
      }
    },

    open() {
      Object.assign(this, this.reset())
      this.$refs.dialog.$loading(() => this.fetchVehicles())
      return this.$refs.dialog.$open()
    },

    async fetchVehicles() {
      let autocomplete = this.txtFilter || 'true'
      this.allVehicles = await Vehicle.findAll({ autocomplete, limit: 10 })
    },

    apply() {
      this.$refs.dialog.$apply({
        vehicleId: this.selectedVehicle.id,
        name: this.ownerName
      })
    },

    selectVehicle(p) {
      this.selectedVehicle = p
      this.currentTab = 2
    }
  }
}
</script>
